module.exports = __webpack_public_path__ + "img/h-page4-58.484c0207.png";